module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-LightItalic.woff2?5e1e50b943e9688aa8dc87e198edbd9d";